import { render, staticRenderFns } from "./unstyled-button.vue?vue&type=template&id=3c26c1e3"
import script from "./unstyled-button.vue?vue&type=script&lang=js"
export * from "./unstyled-button.vue?vue&type=script&lang=js"
import style0 from "./unstyled-button.vue?vue&type=style&index=0&id=3c26c1e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports